const buttonLoader = {
  start(item: HTMLButtonElement, setWidth = true) {
    if (!item) {
      return
    }
    if (setWidth) {
      this.setWidth(item)
    }

    item.classList.add('button--loading')
  },
  reset(item: HTMLButtonElement, setWidth = true) {
    if (!item) {
      return
    }
    if (setWidth) {
      this.setWidth(item, true)
    }
    item.classList.remove('button--loading')
  },

  setWidth(item: HTMLButtonElement, reset = false) {
    if (!item) {
      return
    }

    if (!reset) {
      item.style.width = `${item.offsetWidth}px`

      return
    }

    item.style.width = 'auto'
  },
}

export default buttonLoader
